module.exports = __webpack_public_path__ + "img/vip-img2.f457717e.png";